module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('nav', {
    staticClass: "pull-left"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])]), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.eved.com/about-us/",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('Company')))])]), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.eved.com/news/",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('News')))])]), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.eved.com/careers/",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('Careers')))])]), _c('li', [_vm._v("|")]), _c('li', _vm._l((_vm.langs), function(lang, key) {
    return _c('a', {
      staticClass: "lang",
      class: {
        "active": _vm.isLang(key)
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setLang(key)
        }
      }
    }, [_vm._v(_vm._s(lang))])
  }))])]), _c('p', {
    staticClass: "copyright pull-right"
  }, [_vm._v("© \n" + _vm._s(_vm.year) + " \nEved LLC\n & "), _c('a', {
    attrs: {
      "href": "http://www.dozainer.com"
    }
  }, [_vm._v("dozainer ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1141613d","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer/index.vue
// module id = 0d6a
// module chunks = 13 14